export default __webpack_public_path__ + "static/media/diabeat-it-app-logo.1cb64cc4.png";